import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { TimeAgoBase } from './timeago';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'rtTimeAgo',
  pure: true,
})
export class TimeAgoPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value: string | number,
    { omitSuffix }: { omitSuffix: boolean } = { omitSuffix: false },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, omitSuffix);
  }
}
